//POLIFY

const dummy=function({children}){
    return(
        <div>
            {children}
        </div>
    )
}

export default dummy

export const OffCanvasHeader=dummy
export const OffCanvasBody=dummy